import { render, staticRenderFns } from "./FaturamentoTabs.vue?vue&type=template&id=758d9a4a"
import script from "./FaturamentoTabs.vue?vue&type=script&lang=js"
export * from "./FaturamentoTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports